'use strict';

module.exports = require('./slider');